export const createSvg = (className = ``, width = `18`, height = `18`, link = ``) => {
  const svg = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);

  svg.setAttribute(`class`, className);
  svg.setAttribute(`width`, width);
  svg.setAttribute(`height`, height);
  svg.setAttribute(`aria-hidden`, `true`);

  const use = document.createElementNS(`http://www.w3.org/2000/svg`, `use`);
  use.setAttribute(`href`, link);
  svg.appendChild(use);

  return svg;
};
